import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { OrderDetailEmailStatusControllerModule } from './controllers/OrderDetailEmailStatusController';

export const OrderDetailsEmailStatusView = angular
  .module('acme.view.application.orders.detail.emailStatus', [
    uiRouter,
    'ui.bootstrap',
    OrderDetailEmailStatusControllerModule,
    'acme.common.directive.dataGrid',
    'acme.common.service.userPreferences',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const orderDetailEmailStatus = {
      name: 'application.orders.detail.emailStatus',
      url: '/email',
      views: {
        'subviews-main': {
          controller: 'OrderDetailEmailStatusController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/detail/emailStatus/emailStatus.tpl.html',
        },
      },
      data: {
        pageTitle: 'Order Email Status',
        permissions: ['ORDER_VIEW'],
        enablePreferences: true,
      },
      resolve: {
        EmailStatusList: [
          '$stateParams',
          'ApiService',
          function ($stateParams, ApiService) {
            return ApiService.emailStatus.detail($stateParams.orderId);
          },
        ],
      },
    };

    $stateProvider.state(orderDetailEmailStatus);
  }).name;
